import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import { GlobalStateProvider } from './store/GlobalState';
import { ThemeProvider } from './preferences/ThemeContext';
import { I18nProvider } from './i18n/I18nContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <I18nProvider>
      <ThemeProvider>
        <GlobalStateProvider>
          <App />
        </GlobalStateProvider>
      </ThemeProvider>
    </I18nProvider>
  </React.StrictMode>
);